import classNames from 'classnames2';
import React from 'react';

import { modals as messages } from '../../../../locale/stories.en.locale.json';

import styles from './ReportOption.scss';

interface IReportOptionProps {
  className?: string;
  instancePrefix: string;
  isDisabled?: boolean;
  isFocused?: boolean;
  isSelected?: boolean;
  option: any;
  onFocus?(option, event): void;
  onSelect?(option, event): void;
  onUnfocus?(): void;
  optionIndex?(): number;
  children?: React.ReactNode;
}

export class ReportOption extends React.Component<IReportOptionProps> {
  private dragging: boolean;

  constructor(props) {
    super(props);
  }

  handleMouseDown = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  };

  handleMouseEnter = event => {
    this.onFocus(event);
  };

  handleMouseMove = event => {
    this.onFocus(event);
  };

  handleTouchEnd = event => {
    // Check if the view is being dragged, In this case
    // we don't want to fire the click event (because the user only wants to scroll)
    if (this.dragging) return;

    this.handleMouseDown(event);
  };

  handleTouchMove = () => {
    // Set a flag that the view is being dragged
    this.dragging = true;
  };

  handleTouchStart = () => {
    // Set a flag that the view is not being dragged
    this.dragging = false;
  };

  onFocus = event => {
    if (!this.props.isFocused) {
      this.props.onFocus(this.props.option, event);
    }
  };

  render() {
    const { option, instancePrefix, optionIndex } = this.props;
    const className = classNames(this.props.className, option.className, styles.option);
    let label;

    if (option.isPrivate) {
      label = <div className={styles.label}>{messages.private}</div>;
    }

    if (option.version === 'v2') {
      label = <div className={styles.label}>{messages.new}</div>;
    }

    return option.disabled ? (
      <div className={className}>
        <div>{this.props.children}</div>
        {label}
      </div>
    ) : (
      <div
        className={className}
        style={option.style}
        role="option"
        aria-selected={false}
        aria-label={option.label}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        onTouchStart={this.handleTouchStart}
        onTouchMove={this.handleTouchMove}
        onTouchEnd={this.handleTouchEnd}
        id={`${instancePrefix}-option-${optionIndex}`}
        title={option.title}
      >
        <div>{this.props.children}</div>
        {label}
      </div>
    );
  }
}
